import { Controller } from '@hotwired/stimulus'

// Clears a field's error highlight and inline message as soon as its value
// changes. Attach via app/helpers/field_errors_helper.rb#field_errors_form_data
// on the <form>, and wrap each field (input + shared/_field_error partial)
// in an element with data-field-errors-target="field".
export default class extends Controller {
  static targets = ['field']
  static classes = ['normal', 'error']

  clear(event) {
    const field = event.target.closest('[data-field-errors-target="field"]')
    if (!field) return

    field
      .querySelectorAll('[data-field-errors-message]')
      .forEach((message) => message.remove())

    if (this.hasErrorClass) {
      event.target.classList.remove(...this.errorClasses)
    }
    if (this.hasNormalClass) {
      event.target.classList.add(...this.normalClasses)
    }
  }
}
